import { render, staticRenderFns } from "./trainingBenefits.vue?vue&type=template&id=60a75df8&"
var script = {}
import style0 from "./trainingBenefits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports